import React from 'react';
const Spinner = function () {
    return (
      <div className="w-full spinner"></div>
    );
}
export default Spinner;